import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isCartBoxesSpecialProductsWarningSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { cartBoxesSpecialProductsNotPresentSelector } from '../../../redux/cart/cart.selectors';
import CartBoxesSpecialProductsWarning from './cart-boxes-special-products-warning';
const cartBoxesSpecialProductsWarningTitle = () => 'Hey, before you check out we need you to make some selections';
const cartBoxesSpecialProductsWarningContent = createSelector(cartBoxesSpecialProductsNotPresentSelector, products => {
  const isNotecard = products.find(
  // @todo. auto generated. fix this error
  // @ts-ignore
  prod => prod.specialProductType === SPECIAL_PRODUCT_TYPES.BOX_NOTECARD);
  const isCrinklePaper = products.find(
  // @todo. auto generated. fix this error
  // @ts-ignore
  prod => prod.specialProductType === SPECIAL_PRODUCT_TYPES.BOX_CRINKLE_PAPER);
  const boxNames = [
  // @todo. auto generated. fix this error
  // @ts-ignore
  ...products.reduce(
  // @todo. auto generated. fix this error
  // @ts-ignore
  (productsSet, product) => productsSet.add(product.boxItem.name), new Set())];
  const boxText = boxNames.length > 1 ? `the ${boxNames.map(boxName => `"${boxName}"`).join(', ')} boxes` : `the "${boxNames[0]}" box`;
  if (isNotecard && isCrinklePaper) {
    return `Please choose if you want to add a notecard to ${boxText}. Also let us know what color of crinkle paper you want to be included.`;
  }
  if (isNotecard) {
    return `Please choose if you want to add a notecard to ${boxText}.`;
  } else if (isCrinklePaper) {
    return 'Please let us know what color of crinkle paper you want to be included.';
  }
});
const mapStateToProps = createStructuredSelector({
  open: isCartBoxesSpecialProductsWarningSelector,
  title: cartBoxesSpecialProductsWarningTitle,
  contentText: cartBoxesSpecialProductsWarningContent
});
const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(hidePopup())
});
export default connect(mapStateToProps, mapDispatchToProps)(CartBoxesSpecialProductsWarning);